export const drawerWidth = 248;
export const drawerWidthCollapsed = 64;
